module.exports = __webpack_public_path__ + "static/img/home1.70831ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-500/home1.jpg
// module id = Uod+
// module chunks = 1